import { Store } from 'redux';
import device from 'current-device';
import { trafficSourceInfo } from 'traffic-source-analyzer';
import { AppActions, AppState } from '../../store/initialStateRegistration';
import { getLanguage, getPageType, getSiteName } from '../../store/config/config.selectors';
import { getCountryCode } from '../../templates/templates.utils';
import {
  getArticleId,
  getBlockNames,
  getChannels,
  getCommercialTags,
} from '../../store/template/postPage/postPage.selectors';
import {
  injectArticleBlockByIndexArray,
  InjectArticleBlockByIndexArrayParams,
} from '../../store/template/postPage/postPage.actions';
import { EventHandler } from './eventEmitters';
import {
  GET_PAGE_DATA,
  INJECT_ARTICLE_BLOCK_BY_INDEX_ARRAY,
  INJECT_BUTTON_TO_FOOTER_LINKS_SECTION,
  INJECT_BUTTON_TO_MENU,
  INJECT_VIDEO_LOGO,
} from './events';
import {
  injectButtonToFooterLinksSection,
  injectButtonToMenu,
  injectVideoLogo,
  InjectVideoLogoParams,
} from '../../store/navigation/navigation.actions';
import { InjectButtonParams } from '../../store/navigation/navigation.utils';
import { getIdentifier } from './userIdentifier';

export type ClientAPIWriteEventNames = typeof INJECT_ARTICLE_BLOCK_BY_INDEX_ARRAY | typeof INJECT_VIDEO_LOGO | typeof INJECT_BUTTON_TO_FOOTER_LINKS_SECTION | typeof INJECT_BUTTON_TO_MENU;
export type ClientAPIReadEventNames = typeof GET_PAGE_DATA;

type HandlerCreator = (store: Store<AppState, AppActions>) => EventHandler;
type HandlerCreatorsForWriteEvents = { [key in ClientAPIWriteEventNames]: HandlerCreator }
type HandlerCreatorsForReadEvents = { [key in ClientAPIReadEventNames]: HandlerCreator }

export function getCookieByName(name: string) {
  // @ts-ignore
  return (document.cookie.match(`(^|; )${name}=([^;]*)`) || 0)[2];
}

const createPageData = (state: AppState) => ({
  siteName: getSiteName(state),
  countryCode: getCountryCode(),
  blockNames: getBlockNames(state),
  language: getLanguage(state),
  tags: getCommercialTags(state),
  pageType: getPageType(state),
  articleId: getArticleId(state),
  distributionChannels: getChannels(state),
  platform: device.type,
  trafficSource: trafficSourceInfo.trafficSource,
  trafficSourceAndId: trafficSourceInfo.trafficSourceAndId,
  trafficId: trafficSourceInfo.trafficId,
  mmUserIdentifier: getIdentifier(),
  usState: getCookieByName('stateCode'),
});

export const handlerCreatorsForWriteEvents: HandlerCreatorsForWriteEvents = {
  [INJECT_ARTICLE_BLOCK_BY_INDEX_ARRAY]: (store: Store<AppState, AppActions>) => (params: InjectArticleBlockByIndexArrayParams) => store.dispatch(injectArticleBlockByIndexArray(params)),
  [INJECT_VIDEO_LOGO]: (store: Store<AppState, AppActions>) => (params: InjectVideoLogoParams) => store.dispatch(injectVideoLogo(params)),
  [INJECT_BUTTON_TO_FOOTER_LINKS_SECTION]: (store: Store<AppState, AppActions>) => (params: InjectButtonParams) => store.dispatch(injectButtonToFooterLinksSection(params)),
  [INJECT_BUTTON_TO_MENU]: (store: Store<AppState, AppActions>) => (params: InjectButtonParams) => store.dispatch(injectButtonToMenu(params)),
};

export const handlerCreatorsForReadEvents: HandlerCreatorsForReadEvents = {
  [GET_PAGE_DATA]: (store: Store<AppState, AppActions>) => (callback: Function) => {
    try {
      callback(createPageData(store.getState()));
    } catch (e) {
      console.error(`ClientAPI Error in callback for "${GET_PAGE_DATA}" event. Please check the callback value.`, e);
    }
  },
};
